class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.close();
    });
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    // trigger the CSS animation, then immediately announce "drawer opened"
    setTimeout(() => {
      this.classList.add("animate", "active");
      document.dispatchEvent(new Event("cart-drawer:open"));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const container = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const firstFocus =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(container, firstFocus);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(summary) {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      String(!summary.closest("details").hasAttribute("open"))
    );
    const controlled = summary.nextElementSibling.id;
    if (controlled) summary.setAttribute("aria-controls", controlled);

    summary.addEventListener("click", (evt) => {
      const isOpen = evt.currentTarget.closest("details").hasAttribute("open");
      evt.currentTarget.setAttribute("aria-expanded", String(!isOpen));
    });
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const el = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!el) return;
      el.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // after the drawer content is replaced, re-open & re-bind overlay + announce update
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      document.dispatchEvent(new Event("cart:updated"));
    });

    // re-init currency if you use ACSCurrency
    if (typeof ACSCurrency !== "undefined" && ACSCurrency.moneyFormats)
      mlvedaload();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  setActiveElement(el) {
    this.activeElement = el;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
